import { createApp } from 'vue';
import store from '../../vuex/store';
import router from '../router';
import RoadtripVue from '../components/Roadtrip/Roadtrip.vue';

class Roadtrip {
  constructor(el) {
    const propsData = {
      ...el.dataset,
      countries: el.dataset.countries ? JSON.parse(el.dataset.countries) : [],
      insuranceUrls: el.dataset.insuranceUrls ? JSON.parse(el.dataset.insuranceUrls) : [],
    };
    this.vue = createApp(RoadtripVue, propsData);
    this.vue.use(store);
    this.vue.use(router);
    this.vue.mount(el);
  }

  init() {
    console.log('Component Roadtrip loaded');
  }
}

export default Roadtrip;
